import React from 'react'
import axios from 'axios';
import { Link,useNavigate  } from 'react-router-dom';

const AdminSidebar = () => {
    const handleClick = () => {
        console.log("Link clicked!");
        // Do your logic here
    };

    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await axios.get(`${process.env.REACT_APP_API_BASE}/admin/logout`);
            localStorage.removeItem('token');
            navigate('/admin');
        } catch (err) {
            console.error('Logout failed', err);
            navigate('/admin'); 
        }
    };


  return (
    <div>
    <nav className="navbar bgcolor1 text-white">
        <div className="container-fluid">
            <div className="navbar-header">
                <a href="#" onClick={(e) => { e.preventDefault(); handleClick(); }} className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false"></a>
                <a href="#" onClick={(e) => { e.preventDefault(); handleClick(); }} className="bars"></a>
                <Link className="navbar-brand text-white" to="/admin/dashboard">
                    Fortune Cloud Technologies
                </Link>
            </div>
            <div className="collapse navbar-collapse" id="navbar-collapse">
                
            </div>
        </div>
    </nav>
    <section>
        <aside id="leftsidebar" className="sidebar">
            
            <div className="menu">
                <ul className="list"><br/>
                    <li className="header">Your Menus</li>
                    <li className="active">
                        <Link to="/admin/dashboard">
                            <i className="material-icons">home</i>
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    
                    <li>
                        <Link to="/admin/enquiries">
                            <i className="material-icons col-purple">donut_large</i>
                            <span>Enquiries</span>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/demoenquiries">
                            <i className="material-icons col-purple">donut_large</i>
                            <span>Demo Batch Enquiries</span>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/batchschedule">
                            <i className="material-icons col-light-blue">donut_large</i>
                            <span>Batch Schedule</span>
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/placementcalls">
                            <i className="material-icons col-red">donut_large</i>
                            <span>Free Placement Calls</span>
                        </Link>
                    </li>

                    <li>
                        <a href="/admin/recruiters">
                            <i className="material-icons col-purple">donut_large</i>
                            <span>Recruiters Enquiries</span>
                        </a>
                    </li>

                    <li>
                        <a href="/admin/successstories">
                            <i className="material-icons col-light-green">donut_large</i>
                            <span>Success Stories</span>
                        </a>
                    </li>

                    {/* <li>
                        <a href="/admin_gallery">
                            <i className="material-icons col-purple">donut_large</i>
                            <span>Gallery</span>
                        </a>
                    </li> */}

                    

                    <li>
                        <a href="/admin/blogs">
                            <i className="material-icons">perm_media</i>
                            <span>Blogs</span>
                        </a>
                    </li>

                    {/* <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); handleClick(); }} className="menu-toggle">
                            <i className="material-icons">perm_media</i>
                            <span>Blogs</span>
                        </a>
                        <ul className="ml-menu">
                            <li>
                                <a href="add_blog">Add</a>
                            </li>
                            <li>
                                <a href="view_blog">View</a>
                            </li>
                        </ul>
                    </li> */}
                    {/* <li>
                        <a href="formdataview">
                            <i className="material-icons col-light-blue">donut_large</i>
                            <span>Form Data</span>
                        </a>
                    </li> */}
                    <a onClick={handleLogout} style={{ cursor: 'pointer' }}>
                        <i className="material-icons">input</i>
                        <span>Sign Out</span>
                    </a>
                </ul>
            </div>
            {/* <div className="legal">
                <div className="copyright">
                    &copy;
                    <script>
                        document.write(new Date().getFullYear())
                    </script> <a href="">Fortune Cloud Technologies</a>.
                </div>
            </div> */}
        </aside>
        
    </section>
    </div>
  )
}

export default AdminSidebar